<div class="prize-score">
    <h3 i18n>Tournament prizes:</h3>
    <!-- <p class="list-title" i18n>Tournament position</p> -->
    <ul class="list">
        <li fxLayout="row" fxLayoutAlign="space-between center" class="top-radius opacity-100">
            <div fxFlex="85" i18n>Position</div>
            <div fxFlex="15" style="text-align: right" i18n>Prize</div>
        </li>
        <ng-container *ngIf="prizes">
            <li fxLayout="row" fxLayoutAlign="space-between center" class="top-radius opacity-100">
                <img src="{{licenceService.getKey('icon-gold-cup-1')}}">
                <div fxFlex="85" style="text-align: right">{{prizes[0].name}}</div>
            </li>
            <li fxLayout="row" fxLayoutAlign="space-between center" class="top-radius opacity-100">
                <img src="{{licenceService.getKey('icon-gold-cup-2')}}">
                <div fxFlex="85" style="text-align: right">{{prizes[1].name}}</div>
            </li>
            <li fxLayout="row" fxLayoutAlign="space-between center" class="top-radius opacity-100">
                <img src="{{licenceService.getKey('icon-gold-cup-3')}}">
                <div fxFlex="85" style="text-align: right">{{prizes[2].name}}</div>
            </li>
            <li *ngFor="let item of prizes | slice:3;" fxLayout="row" fxLayoutAlign="space-between center" class="top-radius opacity-100">
                <div fxFlex="15" style="text-align: left">{{item.position}}</div>
                <div fxFlex="85" style="text-align: right">{{item.name}}</div>
            </li>
        </ng-container>
    </ul>
</div>